import { withIdTag } from 'utils/cache'
import {
  CACHE_TAG_CONFIGURED_SERVICE_EVENT_LIST,
  CACHE_TAG_WORK_ORDER_DETAILS,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_WO_SECTION,
  CACHE_TAG_WORK_ORDER_VERSION_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_EVENT_VERSION_LIST,
} from 'api/cacheTagTypes'
import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getWorkOrderDetails: builder.query({
      query: ({ workOrderId }) => {
        return { url: `/api/v1/core/work-orders/${workOrderId}` }
      },
      providesTags: [CACHE_TAG_WORK_ORDER_DETAILS],
    }),
    updateWorkOrderAction: builder.mutation({
      query: ({ workOrderId, action }) => {
        return { url: `/api/v1/core/work-orders/${workOrderId}/action`, method: 'PUT', body: { action } }
      },
      invalidatesTags: (result, error, arg) => [
        CACHE_TAG_CONFIGURED_SERVICE_EVENT_LIST,
        CACHE_TAG_WORK_ORDER_DETAILS,
        CACHE_TAG_WORK_ORDER_LIST,
        CACHE_TAG_WORK_ORDER_LIST_WO_SECTION,
        CACHE_TAG_CONFIGURED_SERVICE_EVENT_VERSION_LIST,
        ...withIdTag(CACHE_TAG_WORK_ORDER_VERSION_LIST, arg?.workOrderId),
      ],
    }),
  }),
})

export const { useLazyGetWorkOrderDetailsQuery, useGetWorkOrderDetailsQuery, useUpdateWorkOrderActionMutation } = extendedApi
